module.exports = __webpack_public_path__ + "static/muffin-or-chihuahua-1-73912fc96f710a2e627d98c2305fe321.jpg";